import 'bootstrap/dist/css/bootstrap.min.css';
import '@/styles/globals.scss';

import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { GiftGoldWelcomeBanner } from '@/common/components/digital-gold';
import FloatingWhatsappIcon from '@/common/components/FloatingWhatsappIcon';
import { Footer } from '@/common/components/Footer/Footer';
import { LandingFooter } from '@/common/components/Footer/LandingFooter';
import { Header } from '@/common/components/Header/Header';
import Loader from '@/common/components/Loader';
import CommonMlpHeader from '@/common/components/MLP/commons/Header';
// import MLPFooter from '@/common/components/MLP/MLPFooter';
import { MLPHeader } from '@/common/components/MLP/MLPHeader';
import { cookiesStorage } from '@/library/storage';
import { AppProvider } from '@/providers/app';
import GTMInitialize from '@/providers/GTMInitialize';
import { protectedRoutes } from '@/routes/protectedRoutes';
import { authConstants } from '@/utils/constants';

import routes from '../routes/routes.json';

export const GiftGoldBannerDisplayRoutes = [
  routes.goldLoan,
  routes.buyGoldLanding,
  routes.forex,
  routes.ncdHome,
];
export default function App({
  Component,
  pageProps,
}: AppProps & {
  Component: { getLayout: (page: React.ReactNode) => React.ReactNode };
}) {
  const router = useRouter();
  const userId = cookiesStorage.getCookie(authConstants.OM_AUTH_USER_ID);
  const [loading, setLoading] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleStart = () => {
      setLoading(true);
    };

    const handleComplete = () => {
      setLoading(false);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [router]);

  // Routes list to display Gift Gold banner popup

  useEffect(() => {
    // checking whether above mentioned routes are included & if user is logged in
    // we are using router.asPath because we need fullPath of routing @ we are using dynamic routing for buy-gold & gift-gold
    if (
      GiftGoldBannerDisplayRoutes.includes(router.asPath) &&
      !!userId &&
      !showBanner
    ) {
      setShowBanner(true);
    } else if (showBanner) {
      setShowBanner(false);
    }
  }, [router.asPath, router.pathname]);

  return (
    <AppProvider>
      <GTMInitialize gtmId="GTM-T4VZ8T7" dataLayerName="MFOneTestDataLayer" />
      <Loader show={loading} />
      {/* Replace it with react query || zustand store TODO */}
      {protectedRoutes.includes(router.pathname) ? (
        <>
          <Header />
          {Component.getLayout ? (
            Component.getLayout(<Component {...pageProps} />)
          ) : (
            <>
              {/* {showBanner && <GiftGoldWelcomeBanner />} */}
              <GiftGoldWelcomeBanner showBanner={showBanner} />
              <Component {...pageProps} />
            </>
          )}
          {router.pathname !== '/gold-loans/loan-appointment' &&
            router.pathname !== '/gold-loans/new-loan' &&
            router.pathname !== '/gold-loans/release-loan' &&
            router.pathname !== '/gold-loans/release-appointment' &&
            router.pathname !== '/gold-loans/top-up' &&
            // router.pathname !== routes.billsRent &&
            router.pathname !== routes.billsPaymentStatus &&
            router.pathname !== routes.billsGst && (
              // router.pathname !== routes.billsVendors &&
              <Footer />
            )}
        </>
      ) : (
        // TODO to write a utility function to return Header and function on pathname
        <>
          {[
            routes.goldLoansApply,
            routes.twoWheelerMlp,
            routes.vmlMlp,
            routes.lapMlp,
          ].includes(router.pathname) || router.pathname === routes.thankYou ? (
            <>
              {router.pathname === routes.goldLoansApply && <MLPHeader />}
              {[routes.twoWheelerMlp, routes.vmlMlp, routes.lapMlp].includes(
                router.pathname
              ) && <CommonMlpHeader />}
              {Component.getLayout ? (
                Component.getLayout(<Component {...pageProps} />)
              ) : (
                <Component {...pageProps} />
              )}
              {/* <MLPFooter /> */}
              {/* <FloatingWhatsappIcon /> */}
            </>
          ) : (
            <>
              {/\/thank-you/i.test(router.asPath) === false ? <Header /> : null}
              {Component.getLayout ? (
                Component.getLayout(<Component {...pageProps} />)
              ) : (
                <>
                  <Component {...pageProps} />
                  {/* {showBanner && <GiftGoldWelcomeBanner />} */}
                  <GiftGoldWelcomeBanner showBanner={showBanner} />
                </>
              )}
              {/\/thank-you/i.test(router.asPath) === false &&
              router.pathname !== routes.billsRent &&
              router.pathname !== routes.billsVendors &&
              router.pathname !== routes.billsLanding ? (
                <LandingFooter />
              ) : null}
              {!userId && <FloatingWhatsappIcon />}
            </>
          )}
        </>
      )}
    </AppProvider>
  );
}
